var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('card',{staticClass:"stacked-form",staticStyle:{"overflow":"visible"}},[_c('box-form',{attrs:{"init-box":{ products: [], barcode: '' },"val-errors":_vm.valErrors,"submit-text":"Erstellen"},on:{"submit":_vm.submit}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }